(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'paginationConstants', 'JhiLanguageService', 'Agence', '$uibModal', '$window', 'AlertService', 'Mfa', '$translate', '$scope', '$interval'];

    function UserManagementController(Principal, User, ParseLinks, paginationConstants, JhiLanguageService, Agence, $uibModal, $window, AlertService, Mfa, $translate, $scope, $interval) {
        var vm = this;

        vm.authorities = ['ROLE_EQUIPMENT_READ', 'ROLE_EQUIPMENT_EDIT', 'ROLE_EQUIPMENT_SECRETS', 'ROLE_EQUIPMENT_REMOTE_CONTROL', 'ROLE_ADMIN', 'ROLE_AREA_CONFIGURATION', 'ROLE_AREA_MANAGEMENT', 'ROLE_DATA_OPERATOR', 'ROLE_COLLECTOR', 'ROLE_SPECIFIC_PRICE', 'ROLE_READ_ONLY', 'ROLE_AI_ASSISTANT', 'ROLE_EVT_EDIT', 'ROLE_EVT_READ_ONLY', 'ROLE_FORM_VALIDATION', 'ROLE_BUDGET_READ_ONLY', 'ROLE_BUDGET_EDIT'];
        vm.agences = Agence.currentOrganisation();
        vm.currentAccount = null;
        vm.languages = null;
        vm.links = null;
        vm.page = 1;
        vm.selection = {};
        vm.selectAllOnPage = false;
        vm.selectedActivated = null;
        vm.selectedAgenceId = null;
        vm.selectedRole = null;
        vm.selectedAndroidDevice = null;
        vm.selectedAppVersion = null;
        vm.selectedMfaEnabled = null;
        vm.totalItems = null;
        vm.users = [];

        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.applyFilters = applyFilters;
        vm.resetFilters = resetFilters;
        vm.setActive = setActive;
        vm.disableMfa = disableMfa;
        vm.toggleSelectAll = toggleSelectAll;
        vm.updateSelectAllState = updateSelectAllState;
        vm.hasSelection = hasSelection;
        vm.selectedCount = selectedCount;
        vm.openBulkEdit = openBulkEdit;
        vm.downloadCsv = downloadCsv;

        vm.stateOptions = [
            { value: null, labelKey: 'userManagement.filters.allStates' },
            { value: true, labelKey: 'userManagement.activated' },
            { value: false, labelKey: 'userManagement.deactivated' }
        ];

        vm.androidDeviceOptions = [
            { value: null, labelKey: 'userManagement.android.allDevices' },
            { value: true, labelKey: 'userManagement.android.yes' },
            { value: false, labelKey: 'userManagement.android.no' }
        ];

        vm.mfaOptions = [
            { value: null, labelKey: 'userManagement.mfa.all' },
            { value: true, labelKey: 'userManagement.mfa.enabled' },
            { value: false, labelKey: 'userManagement.mfa.disabled' }
        ];

        vm.loadAll();

        // Ne remplace pas les lignes : les sélections restent intactes pendant le suivi.
        var presenceRequestPending = false;
        var presenceTimer = $interval(function () {
            if (presenceRequestPending || !vm.users.length) return;
            var currentUsers = vm.users;
            presenceRequestPending = true;
            User.query(buildQueryParams(true), function (result) {
                presenceRequestPending = false;
                if (vm.users !== currentUsers) return;
                var observations = {};
                angular.forEach(result, function (user) { observations[user.id] = user; });
                angular.forEach(currentUsers, function (user) {
                    var observation = observations[user.id];
                    if (!observation) { user.online = false; return; }
                    user.online = observation.online;
                    user.lastLoginDate = observation.lastLoginDate;
                    user.lastSeenDate = observation.lastSeenDate;
                });
            }, function () {
                presenceRequestPending = false;
                // Une présence non vérifiée ne doit pas rester affichée en ligne.
                angular.forEach(currentUsers, function (user) { user.online = false; });
            });
        }, 30000);
        $scope.$on('$destroy', function () { $interval.cancel(presenceTimer); });

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function loadAll () {
            User.query(buildQueryParams(true), function (result, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.users = result;
                resetSelectionState();
            });
        }

        function loadPage (page) {
            vm.page = page;
            vm.loadAll();
        }

        function applyFilters() {
            vm.page = 1;
            vm.loadAll();
        }

        function resetFilters() {
            vm.filter = null;
            vm.selectedRole = null;
            vm.selectedAgenceId = null;
            vm.selectedActivated = null;
            vm.selectedAndroidDevice = null;
            vm.selectedAppVersion = null;
            vm.selectedMfaEnabled = null;
            vm.applyFilters();
        }

        function disableMfa(user) {
            if (!user.mfaEnabled || user.mfaBusy ||
                !$window.confirm($translate.instant('mfa.adminConfirm', {login: user.login}))) { return; }
            user.mfaBusy = true;
            user.mfaError = false;
            // Réutiliser le déblocage administratif et ses contrôles de périmètre côté serveur.
            Mfa.disableForUser(user.login).then(function(status) {
                user.mfaEnabled = status.enabled;
                // Actualiser aussi le total et les résultats lorsque le filtre MFA est actif.
                vm.loadAll();
            }).catch(function() {
                user.mfaError = true;
            }).finally(function() {
                user.mfaBusy = false;
            });
        }

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
            if (vm.editForm) {
                vm.editForm.$setPristine();
                vm.editForm.$setUntouched();
            }
        }

        function toggleSelectAll() {
            angular.forEach(vm.users, function(user) {
                vm.selection[user.id] = vm.selectAllOnPage;
            });
        }

        function updateSelectAllState() {
            var allSelected = vm.users.length > 0;
            angular.forEach(vm.users, function(user) {
                if (!vm.selection[user.id]) {
                    allSelected = false;
                }
            });
            vm.selectAllOnPage = allSelected;
        }

        function hasSelection() {
            return selectedCount() > 0;
        }

        function selectedCount() {
            return getSelectedUserIds().length;
        }

        function openBulkEdit(action) {
            $uibModal.open({
                templateUrl: 'app/components/user-management-bulk-edit/user-management-bulk-edit-dialog.html',
                controller: 'UserManagementBulkEditDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    selectionCount: function () {
                        return selectedCount();
                    },
                    selectedUserIds: function () {
                        return getSelectedUserIds();
                    },
                    action: function () {
                        return action;
                    },
                    agences: function () {
                        return vm.agences;
                    },
                    authorities: function () {
                        return vm.authorities;
                    },
                    bulkService: function () {
                        return User;
                    }
                }
            }).result.then(function () {
                vm.loadAll();
            });
        }

        function downloadCsv() {
            User.exportCsv(buildQueryParams(false), function(result) {
                saveCsvFile(result, 'wamasys-users.csv');
            }, function(error) {
                AlertService.error(resolveErrorMessage(error, 'Export CSV impossible.'));
            });
        }

        function buildQueryParams(includePaging) {
            var params = {};
            if (vm.filter) {
                params.filter = vm.filter;
            }
            if (vm.selectedRole) {
                params.role = vm.selectedRole;
            }
            if (vm.selectedAgenceId) {
                params.agenceId = vm.selectedAgenceId;
            }
            if (vm.selectedActivated === true || vm.selectedActivated === false) {
                params.activated = vm.selectedActivated;
            }
            // Conserver les mêmes critères Android pour la pagination et l’export CSV.
            if (vm.selectedAndroidDevice === true || vm.selectedAndroidDevice === false) {
                params.androidDevice = vm.selectedAndroidDevice;
            }
            if (vm.selectedAppVersion && vm.selectedAppVersion.trim()) {
                params.appVersion = vm.selectedAppVersion.trim();
            }
            // Le filtre MFA est commun au tableau paginé et à l’export.
            if (vm.selectedMfaEnabled === true || vm.selectedMfaEnabled === false) {
                params.mfaEnabled = vm.selectedMfaEnabled;
            }
            if (includePaging) {
                params.page = vm.page - 1;
                params.size = paginationConstants.itemsPerPage;
            }
            return params;
        }

        function getSelectedUserIds() {
            var selectedUserIds = [];
            angular.forEach(vm.users, function(user) {
                if (vm.selection[user.id]) {
                    selectedUserIds.push(user.id);
                }
            });
            return selectedUserIds;
        }

        function resetSelectionState() {
            vm.selection = {};
            vm.selectAllOnPage = false;
        }

        function saveCsvFile(result, defaultFileName) {
            var url = $window.URL || $window.webkitURL;
            var fileName = result.fileName || defaultFileName;

            if ($window.navigator && $window.navigator.msSaveOrOpenBlob) {
                $window.navigator.msSaveOrOpenBlob(result.response, fileName);
                return;
            }

            var downloadLink = angular.element('<a></a>');
            downloadLink.attr('href', url.createObjectURL(result.response));
            downloadLink.attr('download', fileName);
            downloadLink[0].click();
            downloadLink.remove();
        }

        function resolveErrorMessage(error, defaultMessage) {
            if (error && error.data && error.data.message) {
                return error.data.message;
            }
            return defaultMessage;
        }
    }
})();
